//
// // src/api/AxiosConfig.js
// import axios from "axios";
// import { toast } from "react-toastify";
//
// let isRefreshing = false;
// let failedQueue = [];
//
// const api = axios.create({
//     baseURL: `${process.env.REACT_APP_API_URL}/api`,
//     headers: { "Content-Type": "application/json" }
// });
//
// // DEFAULT EXPORT geri geldi! 🔥
// export default api;
//
// export const setupAxios = (auth) => {
//     api.interceptors.request.use((config) => {
//         const token = localStorage.getItem("token");
//         if (token) config.headers.Authorization = `Bearer ${token}`;
//         return config;
//     });
//
//     api.interceptors.response.use(
//         res => res,
//         async err => {
//             const status = err.response?.status;
//             const originalReq = err.config;
//
//             if (status === 401 && !originalReq._retry) {
//                 originalReq._retry = true;
//
//                 const refresh = localStorage.getItem("refreshToken");
//                 if (!refresh) {
//                     auth.logout("Season Expired. Please login again!");
//                     return Promise.reject(err);
//                 }
//
//                 if (isRefreshing) {
//                     return new Promise((resolve, reject) =>
//                         failedQueue.push({ resolve, reject })
//                     );
//                 }
//
//                 isRefreshing = true;
//                 try {
//                     const res = await api.post("/auth/refresh", { refreshToken: refresh });
//                     const newToken = res.data.accessToken;
//
//
//                     localStorage.setItem("token", newToken);
//                     isRefreshing = false;
//
//                     originalReq.headers.Authorization = `Bearer ${newToken}`;
//                     return api(originalReq);
//                 } catch {
//                     auth.logout("Oturum doğrulanamadı. Yeniden giriş yapın.");
//                     return Promise.reject(err);
//                 }
//             }
//
//             return Promise.reject(err);
//         }
//     );
// };
// src/api/AxiosConfig.js
import axios from "axios";
import { toast } from "react-toastify";

let isRefreshing = false;
let failedQueue = [];

const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/api`,
    headers: { "Content-Type": "application/json" }
});

export default api;

export const setupAxios = (auth) => {
    api.interceptors.request.use((config) => {
        const token = localStorage.getItem("token");
        const cartGuid = localStorage.getItem("cart_guid");
        if (token) config.headers.Authorization = `Bearer ${token}`;
        if (cartGuid) config.headers["x-cart-guid"] = cartGuid;
        return config;
    });

    api.interceptors.response.use(
        res => res,
        async err => {
            const status = err.response?.status;
            const originalReq = err.config;

            if (status === 401 && !originalReq._retry) {
                originalReq._retry = true;

                const refresh = localStorage.getItem("refreshToken");
                if (!refresh) {
                    isRefreshing = false;
                                      failedQueue = [];
                    // auth.logout("Session expired. Please login again2!");
                    // return Promise.reject(err);
                    return;
                }

                if (isRefreshing) {
                    return new Promise((resolve, reject) =>
                        failedQueue.push({ resolve, reject })
                    ).then((newToken) => {
                        // kuyruğa alınan istekler için header’ı güncelle
                        originalReq.headers.Authorization = `Bearer ${newToken}`;
                        return api(originalReq);
                    });
                }

                isRefreshing = true;
                try {
                    const res = await api.post("/auth/refresh", { refreshToken: refresh });

                    const newToken = res.data.accessToken;
                    const newRefresh = res.data.refreshToken; // 🔥 backend bunu döndürüyorsa

                    localStorage.setItem("token", newToken);
                    if (newRefresh) {
                        localStorage.setItem("refreshToken", newRefresh);
                    }

                    // Kuyruktakilere haber ver
                    failedQueue.forEach(({ resolve }) => resolve(newToken));
                    failedQueue = [];
                    isRefreshing = false;

                    originalReq.headers.Authorization = `Bearer ${newToken}`;
                    return api(originalReq);
                } catch (e) {
                    failedQueue.forEach(({ reject }) => reject(e));
                    failedQueue = [];
                    isRefreshing = false;

                    isRefreshing = false;
                                       failedQueue = [];
                    auth.logout("Oturum doğrulanamadı. Yeniden giriş yapın.");
                    // return Promise.reject(e);
                    return
                }
            }

            return Promise.reject(err);
        }
    );
};
